import React from 'react';
import { ITableColumns, ITableDataSource } from 'models/table';
import { IConversation } from 'models/application';

export const mapConversationToDataSource = (
  conversation: IConversation[],
): ITableDataSource[] =>
  conversation.map((item) => ({
    id: item.id,
    date: item.date,
    userName: item.userName,
    comment: item.comment,
  }));

export const conversationTableColumns = (): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f513',
    key: 'date',
    title: 'page.applicationDetails.conversation.table.creationDate',
    isSortable: false,
    minWidth: '150px',
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f511',
    key: 'userName',
    title: 'page.applicationDetails.conversation.table.userName',
    isSortable: false,
    minWidth: '150px',
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a7f32f512',
    key: 'comment',
    title: 'page.applicationDetails.conversation.table.comment',
    isSortable: false,
    render: (_data, props) => <div dangerouslySetInnerHTML={{ __html: props.comment }} />,
  },
];
